export default function formatarDataExtensa(dataString: string) {
  const [dia, mes, ano] = dataString.split(' ')[0].split('/');
  const data = new Date(`${ano}-${mes}-${dia}`);

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'long',
    timeZone: 'UTC',
  }).format(data);
}
